import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';

const TemplateGrid = () => {
  const [templates, setTemplates] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        const response = await axios.get('http://localhost:5000/api/templates');
        if (Array.isArray(response.data)) {
          setTemplates(response.data);
        } else {
          console.error('API response is not an array:', response.data);
        }
      } catch (error) {
        console.error('Error fetching templates:', error);
      }
    };
    fetchTemplates();
  }, []);

  const filteredTemplates = Array.isArray(templates)
    ? templates.filter(template =>
        template.name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : [];

  return (
    <div className="min-h-screen bg-stone-100 p-8">
      <div className="max-w-7xl mx-auto">
        <div className="bg-stone-600 text-white p-6 rounded-lg shadow-lg mb-8">
          <h1 className="text-4xl font-bold mb-4">How to Import Templates</h1>
          <p className="text-lg mb-2">1. Copy the code of the template you like.</p>
          <p className="text-lg mb-2">2. Go to the import code section on the dashboard.</p>
          <p className="text-lg mb-2">3. Paste the copied code into the import code section.</p>
          <p className="text-lg mb-2">4. Click on the "Import Code" button.</p>
          <p className="text-lg">5. The template will load on the dashboard.</p>
        </div>

        <h1 className="text-4xl font-bold text-gray-800 mb-8">Website Templates</h1>
        <input
          type="text"
          placeholder="Search templates..."
          className="w-full max-w-2xl mx-auto mb-8 p-4 rounded-lg bg-stone-200 text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500"
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 px-8">
          {filteredTemplates.map((template) => (
            <motion.div
              key={template._id}
              whileHover={{ scale: 1.05 }}
              className="bg-stone-400 rounded-xl overflow-hidden shadow-xl cursor-pointer"
              onClick={() => setSelectedTemplate(template)}
            >
              <img 
                src={`http://localhost:5000${template.imageUrl}`} 
                alt={template.name}
                className="w-full h-48 object-cover"
              />
              <div className="p-4">
                <h3 className="text-gray-800 text-xl mb-2">{template.name}</h3>
                <p className="text-gray-600 mb-4">{template.category}</p>
                <button
                  className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigator.clipboard.writeText(template.code);
                  }}
                >
                  Copy Code
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {selectedTemplate && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg max-w-4xl w-full p-6 relative overflow-y-auto max-h-full">
            <button
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
              onClick={() => setSelectedTemplate(null)}
            >
              ✕
            </button>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">{selectedTemplate.name}</h2>
            <img 
              src={`http://localhost:5000${selectedTemplate.imageUrl}`} 
              alt={selectedTemplate.name}
              className="w-full h-auto mb-4"
            />
            <p className="text-gray-600 mb-4">{selectedTemplate.category}</p>
            <p className="text-gray-600">{selectedTemplate.description}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default TemplateGrid;